// this seems to be necessary as a workaround for the href build issues.
// the Link component does not assume that the process.env variables are available at build time
export const NEXT_PUBLIC_REGISTRATION_SURVEY_URL = "https://tally.so/r/mZ8WV0";

// We accept that this is the production URL for sign-up, not the test one...
export const NEXT_PUBLIC_SIGNUP_URL='https://videohighlight.com/account/register?source=direct'
